/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identificaciónentifier: Apache-2.0
 */

export const savedCartDetails = {
  cartName: 'Nombre',
  cartDescription: 'Descripción',
  cartId: 'IDENTIFICACIÓN',
  dateSaved: 'Fecha de guardado',
  items: 'Artículos',
  quantity: 'Cantidad',
  total: 'Total',
  editSavedCart: 'Editar carrito guardado',
  deleteSavedCart: 'Eliminar carrito guardado',
  addSelectedItems: 'Agregar elementos seleccionados',
  emptyCartItems: 'Empty Cart Artículos',
};

export const savedCartList = {
  savedCarts: 'Carritos guardados ({{count}})',
  cartName: 'Nombre',
  cartId: 'Identificación',
  description: 'Descripción',
  dateSaved: 'Fecha de guardado',
  cartDescription: 'Descripción',
  weight: 'Peso Total (KG)',
  quantity: 'Cantidad',
  total: 'Total',
  actions: 'Acciones',
  makeCartActive: 'Mover a carrito',
  notFound: 'No se han encontrado carritos guardados',
  swapCartNoActiveCart:
    'El carrito existente es activado por {{cartName}} con éxito.',
  swapCartWithActiveCart:
    'El carrito existente es activado por {{cartName}} con éxito. Your previous items were saved in a cart {{{previousCartName}}.',
};

export const savedCartCartPage = {
  messages: {
    cartSalvard:
      'Your cart items have been successfully saved for later in the "{{cartName}}" cart',
  },
};

export const savedCartDialog = {
  saveForLater: 'Guardar para más tarde',
  itemsSavedForLater: 'Todos los artículos de su carrito se guardarán para más tarde',
  savedCartName: 'Número de carrito guardado',
  savedCartDescription: 'Descripción',
  optional: 'opcional',
  charactersLeft: 'Caracteres a la izquierda: {{count}}',
  cancel: 'Cancelar',
  save: 'Guardar',
  restore: 'Restaurar',
  followingCartDelete: 'Se eliminará el siguiente carrito guardado',
  followingCartRestore:
    'El siguiente carrito guardado se restaurará como el carrito activo',
  delete: 'Borrar',
  deleteCartSuccess: 'Carro Borrard con éxito',
  editCartSuccess: 'Carrito editado con éxito',
  editSavedCart: 'Editar carrito guardado',
  deleteSavedCart: 'Eliminar carrito guardado',
  restoreSavedCart: 'Restaurar Carritos Guardados',
  name: 'Nombre',
  id: 'IDENTIFICACIÓN',
  description: 'Descripción',
  quantity: 'Cantidad',
  total: 'Total',
  keepCopySavedCart: 'Guarde una copia de este carrito en la lista de carritos guardados',
  defaultCloneCartNombre: 'Copia de {{name}}',
  nameOfCloneCart: 'Nombre del carrito copiado',
};

export const addToSavedCart = {
  savedCarts: 'Carritos Guardados',
  saveCartForLater: 'Guardar el carrito para más tarde',
};

export const savedCart = {
  savedCartDetails,
  savedCartList,
  savedCartCartPage,
  savedCartDialog,
  addToSavedCart,
};
